package one.healthium.onboarding.ui.models

enum class WeightUnit {
    Lb,
    Kg;

    fun displayValue(): String {
        return when (this) {
            Lb -> "lb"
            Kg -> "kg"
        }
    }
}

fun WeightUnit.correspondingHeightUnit(): HeightUnit {
    return when (this) {
        WeightUnit.Lb -> HeightUnit.Ft
        WeightUnit.Kg -> HeightUnit.Cm
    }
}
